import * as React from 'react';
import { AdvanceCounts } from "../../../../AdvanceNoRocket";
import * as main from '../../styles/main.module.scss';
import * as about from './about.module.scss';

export const About = () => {
  return (
    <section className={about.about}>
      <div className={"container"}>
        <h2 className={main.mainTitle}>Кто мы</h2>
        <div className={about.about__videoAndText}>
          <ul className={about.about__list}>
            <li className={about.about__item}>Мы учим людей раскрывать и развивать свой интеллектуальный потенциал, повышать личную эффективность</li>
            <li className={about.about__item}>Наши технологии используют педагоги и ученики по всей России — от Камчатки до Петербурга</li>
            <li className={about.about__item}>98 школ, 2 вуза и 3 техникума внедрили наши технологии в систему образования</li>
            <li className={about.about__item}>Advance входит в список «100 лидеров новых подходов в образовании» и в перечень проектов, поддерживаемых АНО «Агентство стратегических инициатив» (АСИ)</li>
          </ul>
          <div className={about.about__videoBlock}>
            <div className={about.about__videoWrap}>
              <iframe
                src={"https://65395.servicecdn.ru/videos/65395_msYEVtv2bi9ykzr\n"}
                title={"Об Advance"}
                allow={"autoplay; encrypted-media"}
                allowFullScreen
              >
              </iframe>
            </div>
          </div>
        </div>

        <AdvanceCounts
          container={about.about__numbers}
          colCustomize={about.about__numbersItem}

          yearsTxt={["на рынке", <br/>, "образовательных услуг"]}
          pplCoursesTxt={["выпускников", <br/>, "полных программ"]}
          pplCountTxt={["участников", <br/>, "вебинаров"]}

          numbersType={"text"}
        />
      </div>
    </section>
  );
};
